<section class="change-password-container">
  <header class="header-row">
    <button type="button" class="back-btn" (click)="goBack()">
      <i class="pi pi-arrow-left"></i>
    </button>
    <h1>{{ 'PROFILE.CHANGE_PASSWORD_TITLE' | translate }}</h1>
    <span class="header-spacer"></span>
  </header>

  <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
    <div class="field-group">
      <label class="field-label">{{ 'PROFILE.LABEL_CURRENT_PASSWORD' | translate }}</label>
      <div class="input-wrapper">
        <input class="field-input" [type]="showCurrent ? 'text' : 'password'" formControlName="currentPassword" />
        <button type="button" class="eye-btn" (click)="showCurrent = !showCurrent">
          <i class="pi" [ngClass]="showCurrent ? 'pi-eye-slash' : 'pi-eye'"></i>
        </button>
      </div>
      <div class="error-text" *ngIf="currentPasswordControl?.touched && currentPasswordControl?.hasError('required')">
        {{ 'PROFILE.ERROR_CURRENT_PASSWORD_REQUIRED' | translate }}
      </div>
      <button
        type="button"
        class="forgot-link"
        [disabled]="!hasForgotPasswordRoute"
        (click)="onForgotPassword()"
      >
        {{ 'PROFILE.FORGOT_PASSWORD_LINK' | translate }}
      </button>
    </div>

    <div class="field-group">
      <label class="field-label">{{ 'PROFILE.LABEL_NEW_PASSWORD' | translate }}</label>
      <div class="input-wrapper">
        <input class="field-input" [type]="showNew ? 'text' : 'password'" formControlName="newPassword" />
        <button type="button" class="eye-btn" (click)="showNew = !showNew">
          <i class="pi" [ngClass]="showNew ? 'pi-eye-slash' : 'pi-eye'"></i>
        </button>
      </div>
      <div class="error-text" *ngIf="newPasswordControl?.touched && newPasswordControl?.hasError('required')">
        {{ 'PROFILE.ERROR_CURRENT_PASSWORD_REQUIRED' | translate }}
      </div>
      <div class="error-text" *ngIf="newPasswordControl?.touched && newPasswordControl?.hasError('minlength')">
        {{ 'PROFILE.ERROR_PASSWORD_TOO_SHORT' | translate }}
      </div>
      <div class="error-text" *ngIf="newPasswordControl?.touched && newPasswordControl?.hasError('pattern')">
        {{ 'PROFILE.ERROR_PASSWORD_COMPLEXITY' | translate }}
      </div>
    </div>

    <div class="field-group">
      <label class="field-label">{{ 'PROFILE.LABEL_CONFIRM_PASSWORD' | translate }}</label>
      <div class="input-wrapper">
        <input class="field-input" [type]="showConfirm ? 'text' : 'password'" formControlName="confirmPassword" />
        <button type="button" class="eye-btn" (click)="showConfirm = !showConfirm">
          <i class="pi" [ngClass]="showConfirm ? 'pi-eye-slash' : 'pi-eye'"></i>
        </button>
      </div>
      <div class="error-text" *ngIf="confirmPasswordControl?.touched && confirmPasswordControl?.hasError('required')">
        {{ 'PROFILE.ERROR_CURRENT_PASSWORD_REQUIRED' | translate }}
      </div>
      <div
        class="error-text"
        *ngIf="confirmPasswordControl?.touched && changePasswordForm.hasError('passwordMismatch')"
      >
        {{ 'PROFILE.ERROR_PASSWORDS_DO_NOT_MATCH' | translate }}
      </div>
    </div>
  </form>

  <div class="feedback-msg success" *ngIf="successMessage">{{ successMessage | translate }}</div>
  <div class="feedback-msg error" *ngIf="errorMessage">{{ errorMessage | translate }}</div>

  <div class="save-container">
    <button
      type="submit"
      class="save-btn"
      [disabled]="isSaving || changePasswordForm.invalid"
      (click)="onSubmit()"
    >
      <ng-container *ngIf="!isSaving; else savingTpl">
        {{ 'PROFILE.BTN_SAVE_PASSWORD' | translate }}
      </ng-container>
    </button>
    <ng-template #savingTpl>
      <i class="pi pi-spin pi-spinner"></i>
    </ng-template>
  </div>
</section>
